
export const url = {

    get_presigned_download_url_for_user_guide : '/s3_service/user_guide_presigned_url'
}